export default "__VITE_ASSET__CCErsBKa__"